import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSpareDeliveries, SpareDelivery } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './spareDeliveriesModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SpareDelivery> useData={useSpareDeliveries} config={config} />;
};

export default List;
